import ABreadcrumb from './Breadcrumb.vue'
export default ABreadcrumb


// WEBPACK FOOTER //
// ./src/packages/Breadcrumb/index.js